import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [authed, setAuthed] = useState(false);

  React.useEffect(() => {
    try { setAuthed(!!localStorage.getItem('jwt')); } catch {}
  }, []);

  const logout = () => {
    try {
      ['jwt','email','riskAnalysis','riskCategory','riskScore'].forEach(k => localStorage.removeItem(k));
    } catch {}
    window.location.href = '/sign-in';
  };

  return (
    <header className="bg-black text-white sticky top-0 z-50 border-b border-gray-900">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-5">
        <Link href="/" className="flex items-center gap-3 group">
          <Image src="/ktr_isotipo.svg" alt="" width={32} height={32} />
          <span className="text-base font-light tracking-wide group-hover:text-orange-400 transition-colors">
            KTR Capital
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm font-light">
          <a href="https://ktr.capital" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">KTR Capital</a>
          <Link href="/about" className="text-gray-300 hover:text-white transition-colors">About</Link>
          <Link href="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link>
        </nav>

        <div className="hidden md:flex gap-2 items-center">
          {authed ? (
            <>
              <Link href="/dashboard" className="text-sm font-light text-gray-300 hover:text-white transition-colors px-4 py-2">Dashboard</Link>
              <button onClick={logout} className="text-sm font-medium text-gray-200 border border-gray-700 hover:bg-gray-900 transition-colors px-5 py-2 rounded">Sign out</button>
            </>
          ) : (
            <>
              <Link href="/sign-in" className="text-sm font-light text-gray-300 hover:text-white transition-colors px-4 py-2">Investor sign in</Link>
              <Link href="/sign-up" className="text-sm font-medium text-black bg-orange-500 hover:bg-orange-600 transition-colors px-5 py-2 rounded">Sign up</Link>
            </>
          )}
        </div>

        <button
          className="md:hidden focus:outline-none rounded p-1"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            {isOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black border-t border-gray-900 px-6 py-4 space-y-3 text-sm font-light">
          <a href="https://ktr.capital" target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-white py-2 transition-colors">KTR Capital</a>
          <Link href="/about" className="block text-gray-300 hover:text-white py-2 transition-colors">About</Link>
          <Link href="/contact" className="block text-gray-300 hover:text-white py-2 transition-colors">Contact</Link>
          <hr className="border-gray-800 my-3" />
          {authed ? (
            <>
              <Link href="/dashboard" className="block text-gray-300 hover:text-white py-2 transition-colors">Dashboard</Link>
              <button onClick={logout} className="block w-full text-left text-gray-300 hover:text-white py-2 transition-colors">Sign out</button>
            </>
          ) : (
            <>
              <Link href="/sign-in" className="block text-gray-300 hover:text-white py-2 transition-colors">Investor sign in</Link>
              <Link href="/sign-up" className="block text-center text-black bg-orange-500 hover:bg-orange-600 py-2.5 rounded font-medium transition-colors">Sign up</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
